import React from "react";
import completedIcon from "../../../assets/icons/newDesign/completed.svg";
import "./styles.css";

export interface CompletedBadgeProps {
  /** Extra class for size / positioning overrides from the parent */
  className?: string;
}

const CompletedBadge: React.FC<CompletedBadgeProps> = ({ className = "" }) => (
  <span className={`completed-badge ${className}`.trim()} aria-hidden="true">
    <img src={completedIcon} alt="" className="completed-badge__icon" />
  </span>
);

export default CompletedBadge;
